// @flow

import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import Fieldset from '@clark-inc/clark-forms';
import { Grid, Row, Col, Cta, Header } from 'clark-styles';
import { postTutorSignIn } from 'actions/tutor';

import Wrapper from 'components/shared/wrapper';
import CopyLink from 'components/shared/copy-link';
import SectionHeader from 'components/shared/section-header';

import { HEADLINE, FIELD_SETS } from 'constants/sign-in';
import Background from './styles';

const mapStateToProps = ({ application: { flash, isLoading } }) => ({
  flash,
  isLoading,
});

const mapDispatchToProps = { dispatchPostTutorSignIn: postTutorSignIn };

const formConfig = {
  form: 'signIn',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
};

const enhancer = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  reduxForm(formConfig),
);

const SignIn = ({ flash, isLoading, dispatchPostTutorSignIn, handleSubmit }) => (
  <div>
    <Header />
    <Wrapper hasFlash={!!flash}>
      <Background>
        <Grid>
          <Row>
            <Col sm={12} mdOffset={3} md={6} lgOffset={3} lg={6}>
              <SectionHeader headline={HEADLINE} />
              <form onSubmit={handleSubmit(values => dispatchPostTutorSignIn(values))}>
                <Fieldset data={FIELD_SETS} />
                <CopyLink link="/forgot-password" linkCopy="Forgot your password?" />
                <Cta controlledLoading={isLoading}>Sign In</Cta>
              </form>
            </Col>
          </Row>
        </Grid>
      </Background>
    </Wrapper>
  </div>
);

export default enhancer(SignIn);



// WEBPACK FOOTER //
// ./src/screens/sign-in/index.js